import { render, staticRenderFns } from "./decoration.vue?vue&type=template&id=353595d9"
import script from "./decoration.vue?vue&type=script&lang=js"
export * from "./decoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports